export default __webpack_public_path__ + "images/a6a609a6-download.svg";